import {css} from "@emotion/react";
import React from 'react';
import {DetailsIcon} from "../../../AirQualityMonitoring/components/DataListCard/components/DetailsIcon";
import {Table, TableProps} from "../../../AirQualityMonitoring/components/DataListCard/components/Table";
import {useAuth} from "../../../Auth";
import {TSMMonitoringContext} from "../../components/TSMMonitoringProvider";
import {EditSvgIcon} from "../EditSvgIcon";
import {useTrainsByPeriod} from "../../../../sdk/queries";
import moment from "moment"

export interface TSMTrainsTableProps {
    onView?(id: number): void;
    location_id: number,
    period_s: string
}

export const TSMTrainsTable: React.FC<TSMTrainsTableProps> = ({
    onView,
    location_id,
    period_s
}) => {

    const auth = useAuth()

    const a_trains = useTrainsByPeriod({
	variables: {
	    id: String(location_id),
	    period_date: period_s,
	}
    });

    const allTrains = (a_trains?.data?.data || []);
    
    const trainListData: TableProps['data'] = [{
        name: "Train ID",
        values: allTrains.map(x => x.name),
    }, {
        name: "Train Pass Date/Time",
        values: allTrains.map(x => moment(x.start_at).format("MM-DD-yyyy HH:mm")),
    }, {
      name: "Has Met Coal",
      values: allTrains.map(x => x.met_train),
    },{
      name: "Speed",
      values: allTrains.map(x => x.avg_speed != null ? x.avg_speed : "--"),
    }, {
        name: "Type",
        values: allTrains.map(x => x.type),
    }, {
      name: "IDV",
      values: allTrains.map(x => x.idv),
    }, {
        name: "Details",
        values: allTrains.map(x => <div css={css({
            display: "flex",
            flex: 1,
            alignItems: "center",
            width: 80,
            justifyContent: "center",
        })}>

            <DetailsIcon
                onClick={() => onView?.(x.id)}/>
        </div>),
    }];

    const filterName = auth.userRole != "admin" ? "IDV" : "";
    
    const filteredTrainListData = trainListData
	.filter(item => item.name !== filterName);
    
    return (
        <Table data={filteredTrainListData} fullWidth={true}/>
    );
}
